import { render, staticRenderFns } from "./title-preview.vue?vue&type=template&id=0b1941bf&"
import script from "./title-preview.vue?vue&type=script&lang=js&"
export * from "./title-preview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports